import * as React from 'react';

const SelectIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    xmlns="http://www.w3.org/2000/svg">
    <g
      id="Screens"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="B---01-Work-Station---01.02-Lenses"
        transform="translate(-787 -448)">
        <g id="Item-1" transform="translate(135 323)">
          <g id="Lenses" transform="translate(600 81)">
            <g id="prescription-details" transform="translate(48 42)">
              <path id="Base" opacity=".2" d="M0 0h24v24H0z" />
              <path
                d="M18 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12zm-8 15H8a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm4-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm-4-4H8a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2zm4-4H8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2z"
                id="Prescription"
                fill="#4A4F4A"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SelectIcon;
